<div class="profile">
  <div class="profile-img-container">
    <img [src]="immagineProfilo" class="profile-img" />
    <button mat-raised-button color="primary" (click)="goToChangeImage()">Cambia immagine</button>
  </div>
  <div>
    <h3>{{nomeUtente}}</h3>
  </div>
  <div class="cf">
    <h4>CF: {{codiceFiscale}}</h4>
  </div>
  <div>
    Medico: {{nomeMedico}}
  </div>
  @if (isPagamentiVisibile) {
    <div>
      Scadenza abbonamento: {{dataScadenzaAbbonamento}}
    </div>
  }
  <button mat-raised-button class="change-doctor-button" (click)="openChangeDoctor()">
    Richiesta cambio medico
  </button>
</div>
